import { render, staticRenderFns } from "./Distributeurs.vue?vue&type=template&id=5d91c08b"
import script from "./Distributeurs.vue?vue&type=script&lang=js"
export * from "./Distributeurs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports